<template>
	<paginated-search v-bind="{ schema, searchEntities, openEntity, createEntity, autoEnable: true }"></paginated-search>
</template>

<script>
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import Podcast from "@/models/podcast.model.vue";

	export default {
		components: {
			PaginatedSearch,
		},
		data () {
			return {
				schema: Podcast.getSchema(),
			};
		},
		methods: {
			openEntity(entity) {
				this.$router.push(`/podcast/${entity.id}`);
			},
			createEntity() {
				this.$router.push(`/podcast/novo`);
			},
			searchEntities(paginationParameters) {
				return Podcast.search(paginationParameters);
			},
		},
	}
</script>
